import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { getUserSchemes, getAllSchemes } from "../actions/scheme-action-types";
import CaseWeb from "../CaseWeb";
import { GenerateUserToken } from "../utilities/utilsFunction";
import { Circle } from "../components/Overlay";

const CustomerSchemes = ({ match, getUserSchemes, userSchemes, visible }) => {
  const { customerCode, token, langId } = match.params;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchSchemes();
  }, []);

  const fetchSchemes = async () => {
    setIsLoading(true);
    try {
      const freshToken = await GenerateUserToken("");
      getUserSchemes({
        customerId: customerCode,
        appId: "CA0001",
        token: freshToken.data,
      });
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <Circle size="Large" top={"40%"} />
      ) : (
        <CaseWeb
          userSchemes={userSchemes?.userSchemes ?? []}
          langId={langId}
          visible={visible}
        />
      )}
    </>
  );
};

const mapStateToProps = ({
  app: { visible },
  schemes: { allSchemes, userSchemes },
}) => ({
  allSchemes,
  visible,
  userSchemes,
});

export default connect(mapStateToProps, {
  getUserSchemes: getUserSchemes,
  getAllSchemes: getAllSchemes,
})(CustomerSchemes);
